import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);

new Swiper( '.c-carousel--article-triple .swiper', {
	speed: 600,
	slidesPerView: 1,
	spaceBetween: 25,
	navigation: {
		nextEl: '.c-carousel__button--next',
		prevEl: '.c-carousel__button--prev',
		disabledClass: 'c-carousel__button--disabled',
		lockClass: 'c-carousel__button--locked',
	},
	pagination: {
		el: '.c-carousel__pagination',
		bulletClass: 'c-carousel__bullet',
		bulletActiveClass: 'c-carousel__bullet--current',
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
		},
		1290: {
			slidesPerView: 3,
		},
	}
} );

new Swiper( '.c-carousel--article-double .swiper', {
	speed: 600,
	slidesPerView: 1,
	spaceBetween: 25,
	navigation: {
		nextEl: '.c-carousel__button--next',
		prevEl: '.c-carousel__button--prev',
		disabledClass: 'c-carousel__button--disabled',
		lockClass: 'c-carousel__button--locked',
	},
	pagination: {
		el: '.c-carousel__pagination',
		bulletClass: 'c-carousel__bullet',
		bulletActiveClass: 'c-carousel__bullet--current',
		clickable: true,
	},
	breakpoints: {
		992: {
			slidesPerView: 2,
		},
	}
} );

new Swiper( '.c-carousel--article-single .swiper', {
	speed: 600,
	slidesPerView: 1,
	navigation: {
		nextEl: '.c-carousel__button--next',
		prevEl: '.c-carousel__button--prev',
		disabledClass: 'c-carousel__button--disabled',
		lockClass: 'c-carousel__button--locked',
	},
	pagination: {
		el: '.c-carousel__pagination',
		bulletClass: 'c-carousel__bullet',
		bulletActiveClass: 'c-carousel__bullet--current',
		clickable: true,
	}
} );


new Swiper( '.c-carousel--podcasts .swiper', {
	speed: 600,
	slidesPerView: 1,
	spaceBetween: 25,
	navigation: {
		nextEl: '.c-carousel__button--next',
		prevEl: '.c-carousel__button--prev',
		disabledClass: 'c-carousel__button--disabled',
		lockClass: 'c-carousel__button--locked',
	},
	pagination: {
		el: '.c-carousel__pagination',
		bulletClass: 'c-carousel__bullet',
		bulletActiveClass: 'c-carousel__bullet--current',
		clickable: true,
	},
	breakpoints: {
		576: {
			slidesPerView: 2,
		},
		1290: {
			slidesPerView: 3,
		},
	}
} );


new Swiper( '.c-carousel--gallery .swiper', {
	speed: 600,
	slidesPerView: 1.5,
	centeredSlides: true,
	loop: true,
	navigation: {
		nextEl: '.c-carousel__button--next',
		prevEl: '.c-carousel__button--prev',
		disabledClass: 'c-carousel__button--disabled',
		lockClass: 'c-carousel__button--locked',
	},
	breakpoints: {
		768: {
			slidesPerView: 2.5,
		}
	}
} );

new Swiper( '.c-carousel--feature .swiper', {
	speed: 600,
	slidesPerView: 1,
	loop: true,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	navigation: {
		nextEl: '.c-carousel__button--next',
		prevEl: '.c-carousel__button--prev',
		disabledClass: 'c-carousel__button--disabled',
		lockClass: 'c-carousel__button--locked',
	},
	pagination: {
		el: '.c-carousel__pagination',
		bulletClass: 'c-carousel__bullet',
		bulletActiveClass: 'c-carousel__bullet--current',
		clickable: true,
	}
} );

new Swiper( '.c-carousel--text .swiper', {
	autoplay: {
		delay: 5000,
	},
	speed: 1000,
	slidesPerView: 1,
	loop: true,
	autoHeight: true,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
} );